export default __webpack_public_path__ + "static/media/invoiceIcon.fcde0b80.svg";